import { createAction, props } from '@ngrx/store';

import { ErrorResponse } from '#types/core';
import { Filters, Sorts } from '#types/grid';
import { ItemLookupResponseBody, lotRequiredCheckOnItemResponseBody } from '#types/item';
import { ListOfValuesResponse, MultipleListOfValuesResponse } from '#types/list';

//
// item / request lists
//

export const RequestLists = createAction('[Item] - Request Lists');

//
// item lists
//

export const RequestItemLists = createAction('[Item.List] - Request Item Lists');
export const RequestItemListsSuccess = createAction(
  '[Item.List] - Request Item Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestItemListsFailure = createAction('[Item.List] - Request Item Lists Failure', props<{ error: ErrorResponse }>());

//
// item / lookup dialog
//

export const ItemLookupDialogRequestData = createAction('[Item.Lookup.Dialog] - Grid Request Data', props<{ id: string }>());
export const ItemLookupDialogRequestDataWithParameters = createAction(
  '[Item.Lookup.Dialog] - Grid Request Data With Parameters',
  props<{ id: string; filters: Filters; page: number; first: number; rows: number; sorts: Sorts }>()
);
export const ItemLookupDialogRequestDataWithFilters = createAction(
  '[Item.Lookup.Dialog] - Grid Request Data With Filters',
  props<{ id: string; filters: Filters }>()
);
export const ItemLookupDialogRequestDataSuccess = createAction(
  '[Item.Lookup.Dialog] - Grid Request Data Success',
  props<{ id: string; data: ItemLookupResponseBody }>()
);
export const ItemLookupDialogRequestDataFailure = createAction('[Item.Lookup.Dialog] - Grid Request Data Failure', props<{ id: string }>());

//
// item / customer product group list
//

export const RequestItemCustomerProductGroupList = createAction(
  '[Item.List] - Request Item Customer Product Group List',
  props<{ custid: string }>()
);
export const RequestItemCustomerProductGroupListSuccess = createAction(
  '[Item.List] - Request Item Customer Product Group List Success',
  props<{ list: ListOfValuesResponse; custid: string }>()
);
export const RequestItemCustomerProductGroupListFailure = createAction(
  '[Item.List] - Request Item Customer Product Group List Failure',
  props<{ error: ErrorResponse }>()
);

//
// item / customer rate group list
//

export const RequestItemCustomerRateGroupList = createAction(
  '[Item.List] - Request Item Customer Rate Group List',
  props<{ custid: string }>()
);
export const RequestItemCustomerRateGroupListSuccess = createAction(
  '[Item.List] - Request Item Customer Rate Group List Success',
  props<{ list: ListOfValuesResponse; custid: string }>()
);
export const RequestItemCustomerRateGroupListFailure = createAction(
  '[Item.List] - Request Item Customer Rate Group List Failure',
  props<{ error: ErrorResponse }>()
);

//
// item / lotrequiredcheck
//

export const RequestlotRequiredCheckOnItem = createAction(
  '[Item.LotRequired] - Request Item Lot Required Check',
  props<{ custid: string; item: string }>()
);
export const RequestlotRequiredCheckOnItemSuccess = createAction(
  '[Item.LotRequired] - Request Item Lot Required Check Success',
  props<{ data: lotRequiredCheckOnItemResponseBody }>()
);
export const RequestlotRequiredCheckOnItemFailure = createAction(
  '[Item.LotRequired] - Request Item Lot Required Check Failure',
  props<{ error: ErrorResponse }>()
);
